import React from 'react'
import { Grid, Link, Typography } from '@mui/material'
import Avatar from '@mui/material/Avatar'
import initials from 'initials'
import { useStyles } from './style'
import { Link as RouterLink } from 'react-router-dom'
import { authorUrl } from '../../../helpers/url'
const defaultColors = [
  '#2ecc71', // emerald
  '#3498db', // peter river
  '#8e44ad', // wisteria
  '#e67e22', // carrot
  '#e74c3c', // alizarin
  '#1abc9c', // turquoise
  '#2c3e50' // midnight blue
]

const defaultName = 'The Mindtools Content Team'

const Creator = ({ name, slug = null, author = false }) => {
  const creatorName = React.useMemo(
    () => (author ? (name?.length > 0 ? name : defaultName) : name),
    [name, author]
  )
  const creatorStatusText = author ? 'Written by' : 'Reviewed by'
  const backgroundColor =
    defaultColors[creatorName.length % defaultColors.length]
  const classes = useStyles({ backgroundColor })

  if (!creatorName) {
    return null
  }

  return (
    <Grid
      container
      alignItems='baseline'
      wrap='nowrap'
      spacing={2}
      className={classes.root}
    >
      <Grid item>
        <Avatar className={classes.avatar}>
          {creatorName === defaultName
            ? initials(creatorName.slice(3))
            : initials(creatorName)}
        </Avatar>
      </Grid>
      <Grid item className={classes.name}>
        {!author || !slug
          ? (
            <Typography
              component='span'
              data-test='article-author-name'
            >
              {creatorStatusText} {creatorName}
            </Typography>
            )
          : (
            <Link
              noWrap
              underline='hover'
              className={classes.link}
              data-test='article-author-name'
              component={RouterLink}
              to={authorUrl(slug)}
            >
              {creatorStatusText} {creatorName}
            </Link>
            )}
      </Grid>
    </Grid>
  )
}

export default Creator
